import {FormikHelpers} from 'formik';
import {notify} from '@gemcook/notification';

import resources from '@resources';
import constants from '@constants';
import api from '@api';
import paths from '@paths';
import utils from '@utils';

export const create = async (
  value: any,
  formikHelpers: FormikHelpers<any>,
  action: UsersAction,
  history: any,
  me: MeStore,
  setIsModal: React.Dispatch<React.SetStateAction<boolean>>
) => {
  formikHelpers.setSubmitting(true);

  try {
    const birthdate = resources.users.getBirthDate(
      value.birthyear,
      value.birthmonth,
      value.birthday
    );

    // 登録人数が1000人を超える場合Congnito登録前にエラーにする （登録メールを送信させないようにする為）
    if (me.plan !== constants.PLAN.SAFETY_X) {
      const users = await api.users.getUsersCount({teamId: me.teamId});

      if (users.count >= constants.PLAN.MAX_CAPACITY_COUNT) {
        throw new Error('team capacity is 1000 max');
      }
    }

    await api.users.isUsersUnique({
      email: value.email,
      teamId: me.teamId,
      phoneNumber: value.phoneNumber ? value.phoneNumber : undefined,
    });

    if (value.authLevel === constants.AUTHORITIES.ADMIN && value.email) {
      await api.users.isLoginUsersUnique({
        email: value.email,
      });
      const b: UserPostCognitoUser = {
        email: value.email,
      };
      const res = await api.users.createCognitoUser(b);

      await action.users.createUser({
        ...value,
        sub: res.sub,
        cognitoUserName: res.sub,
        birthdate,
      });

      await utils.stripe.updateUsage(me);

      notify(
        `新しく追加した管理者にログイン情報をメールで送信しました。`,
        'success'
      );
      history.push(paths.users.main);
    } else {
      await action.users.createUser({...value, birthdate});

      await utils.stripe.updateUsage(me);

      notify(
        resources.users.getNotifyMessage('success', 'create', 'user'),
        'success'
      );
      setIsModal(true);
    }

    formikHelpers.setSubmitting(false);
  } catch (error) {
    // APIが返すエラーがあった場合
    if (error.response) {
      switch (error.response.data.message) {
        case 'UsernameExistsException: An account with the given email already exists.': {
          notify(constants.ERRORS.EXISTED_EMAIL, 'error');
          break;
        }
        case 'An account with the given email already exists.':
          notify(constants.ERRORS.EXISTED_EMAIL, 'error');
          break;
        case 'email is not unique': {
          notify(constants.ERRORS.EXISTED_EMAIL_TEAM, 'error');
          break;
        }
        case 'phoneNumber is not unique': {
          notify(constants.ERRORS.EXISTED_PHONE_NUMBER, 'error');
          break;
        }
        default: {
          notify(constants.ERRORS.UNKNWON, 'error');
          break;
        }
      }
      return;
    }
    // プラン上限を超える場合のエラー
    if (error.message) {
      switch (error.message) {
        case 'team capacity is 1000 max': {
          notify(
            'プランの登録上限人数を超えてしまいます。プランを変更してください',
            'error'
          );
          break;
        }

        default: {
          notify(constants.ERRORS.UNKNWON, 'error');
          break;
        }
      }
    }
  } finally {
    formikHelpers.setSubmitting(false);
  }
};
